// Function to get a parameter from the URL
function getURLParameter(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [,""])[1].replace(/\+/g, '%20')) || null;
}

// Get the 'code' parameter from the URL or from local/session storage
var code = getURLParameter('code') || localStorage.getItem('affiliateCode') || sessionStorage.getItem('affiliateCode');
if(code){
    code = code.toUpperCase();
}

// Function to modify the header
function modifyHeader(header) {
  var styles = window.headerColors[code];
  if (styles) {
    header.style.backgroundColor = styles.background;
    header.style.color = styles.color;
  }
}

// Look for the '.dynamic__header' element and apply styles
var headers = document.querySelectorAll('.dynamic__header');
headers.forEach(modifyHeader);

// -------------------------------------------------------------------------------------------------------------------------------

// Function to modify the Primary button
function modifyButton(button) {
  var styles = window.buttonColors[code];
  if (styles) {
    button.style.backgroundColor = styles.background;
    button.style.color = styles.color;

    // Add event listeners for hover
    button.addEventListener('mouseover', function() {
      button.style.backgroundColor = styles.hoverBackground;
      button.style.color = styles.hoverColor;
    });
    button.addEventListener('mouseout', function() {
      button.style.backgroundColor = styles.background;
      button.style.color = styles.color;
    });
  }
}

// Look for the '.dynamic_primary_color' element and apply styles
var buttons = document.querySelectorAll('.dynamic_primary_color');
buttons.forEach(modifyButton);

// -------------------------------------------------------------------------------------------------------------------------------

// Function to modify the footer
function modifyFooter(footer) {
  var styles = window.footerColors[code];
  if (styles) {
    footer.style.backgroundColor = styles.background;
    footer.style.color = styles.color;
  }
}

// Look for the '.dynamic_footer' element and apply styles
var footers = document.querySelectorAll('.dynamic_footer');
footers.forEach(modifyFooter);